@switch (publishingMode) {

  @case (publishingModes.ByInvitationOnly) {
    <app-by-invitation-access-section
      [isCourse]="isCourse"
    ></app-by-invitation-access-section>
  }

  @case (publishingModes.DeployToTargetGroup) {
    <app-target-group-section
      [isViewMode]="isViewMode"
      [isPrivatePublishing]="isPrivatePublishing"
      [isCourse]="isCourse"
      [personCount]="personCount"

      [visibilityMode]="visibilityMode!"
      (visibilityModeChange)="visibilityModeChange.emit($event)"

      [selectedOrganizationUnitIds]="selectedOrganizationUnitIds"
      (selectedOrganizationUnitIdsChange)="selectedOrganizationUnitIdsChange.emit($event)"

      [allowSharingWithSubscribers]="allowSharingWithSubscribers"
      (allowSharingWithSubscribersChange)="allowSharingWithSubscribersChange.emit($event)"

      [trainingGroupIds]="trainingGroupIds"
      (trainingGroupIdsChange)="trainingGroupIdsChange.emit($event)"

      [trainingCategoryIds]="trainingCategoryIds"
      (trainingCategoryIdsChange)="trainingCategoryIdsChange.emit($event)"

      [subscriptionIds]="subscriptionIds"
      (subscriptionIdsChange)="subscriptionIdsChange.emit($event)"

      [standardTrainingCategoryIds]="standardTrainingCategoryIds"
      (standardTrainingCategoryIdsChange)="standardTrainingCategoryIdsChange.emit($event)"

      [roleIds]="roleIds"
      (roleIdsChange)="roleIdsChange.emit($event)"

      [organizationUnits]="organizationUnits"
      [trainingGroups]="trainingGroups"
      [trainingCategories]="trainingCategories"
      [subscribers]="subscribers"
      [standardTrainingCategories]="standardTrainingCategories"
      [roles]="roles"
      [usedStandardTrainingCategories]="usedStandardTrainingCategories"
    ></app-target-group-section>
  }

  @case (publishingModes.PublishToCatalogue) {
    <app-publish-to-catalogue-section
      [isViewMode]="isViewMode"
      [isCourse]="isCourse"
      [personCount]="personCount"

      [visibilityMode]="visibilityMode!"
      (visibilityModeChange)="visibilityModeChange.emit($event)"

      [organisationUnitIds]="selectedOrganizationUnitIds"
      (organisationUnitIdsChange)="selectedOrganizationUnitIdsChange.emit($event)"

      [trainingGroupIds]="trainingGroupIds"
      (trainingGroupIdsChange)="trainingGroupIdsChange.emit($event)"

      [trainingCategoryIds]="trainingCategoryIds"
      (trainingCategoryIdsChange)="trainingCategoryIdsChange.emit($event)"

      [organizationUnits]="organizationUnits"
      [trainingGroups]="trainingGroups"
      [trainingCategories]="trainingCategories"
    ></app-publish-to-catalogue-section>
  }

  @case (publishingModes.PublishToSubscribers) {
    <app-publish-to-subscribers-section
      [isViewMode]="isViewMode"
      [personCount]="personCount"

      [visibilityMode]="visibilityMode!"
      (visibilityModeChange)="visibilityModeChange.emit($event)"

      [selectedOrganizationUnitIds]="selectedOrganizationUnitIds"
      (selectedOrganizationUnitIdsChange)="selectedOrganizationUnitIdsChange.emit($event)"

      [trainingGroupIds]="trainingGroupIds"
      (trainingGroupIdsChange)="trainingGroupIdsChange.emit($event)"

      [subscriptionIds]="subscriptionIds"
      (subscriptionIdsChange)="subscriptionIdsChange.emit($event)"

      [roleIds]="roleIds"
      (roleIdsChange)="roleIdsChange.emit($event)"

      [standardTrainingCategoryIds]="standardTrainingCategoryIds"
      (standardTrainingCategoryIdsChange)="standardTrainingCategoryIdsChange.emit($event)"

      [trainingCategoryIds]="trainingCategoryIds"
      (trainingCategoryIdsChange)="trainingCategoryIdsChange.emit($event)"

      [organizationUnits]="organizationUnits"
      [trainingGroups]="trainingGroups"
      [subscribers]="subscribers"
      [roles]="roles"
      [standardTrainingCategories]="standardTrainingCategories"
      [trainingCategories]="trainingCategories"
      [usedStandardTrainingCategories]="usedStandardTrainingCategories"
    ></app-publish-to-subscribers-section>
  }
}